export default Object.freeze({
  EXTRACTED_DATA: 'EXTRACTED_DATA',
  PRISMA_STATISTICS: 'PRISMA_STATISTICS',
  FULL_TEXT_PDFS: 'FULL_TEXT_PDFS',
});
